// extracted by mini-css-extract-plugin
module.exports = {"tableSizeSelector":"uxMOK","buttonGroup":"ucHUM"};